import { AccountResponseDto, AccountTypeDto } from '@core/api/generated/accounts/v1';
import { createReducer, on } from '@ngrx/store';
import { loadUser } from '@store/actions/user.actions';

export const initialState: AccountResponseDto = {
    accountType: AccountTypeDto.Business,
    addressId: '',
    allVehiclesDeleted: false,
    appId: 'NEXTPASS_FLEETS',
    appsFlyerId: '',
    companyName: '',
    email: '',
    firstTimeReady: false,
    hasTransponder: false,
    id: '',
    identityProvider: '',
    maxPaymentAttempts: 0,
    middleName: '',
    name: '',
    paymentAttempts: 0,
    paymentMethodRegistered: false,
    phoneNumber: '',
    profileCompleted: false,
    registrationChannel: 'WEB',
    status: 'PENDING',
    surname: '',
    termsAndConditionsAccepted: false,
    userInfoReviewed: false,
    vehicleCreated: false,
};

export const userReducer = createReducer(
    initialState,
    on(loadUser, (state, action) => {
        return {
            ...action.user,
        };
    })
);
